import BusinessCategoriesAPI from '@/API/super-admin/business-categories-api'

export default {
  namespaced: true,
  state: {
    businessCategories: [],
    allBusinessCategories: [],
    businessCategoriesFetched: false,
    businessCategoriesLoading: false,
  },

  getters: {
    businessCategories: (state: any) => state.businessCategories,
    businessCategoriesFetched: (state: any) => state.businessCategoriesFetched,
    allBusinessCategories: (state: any) => state.allBusinessCategories,
  },

  mutations: {
    SET_BUSINESS_CATEGORIES(state: any, businessCategories: any) {
      state.businessCategories = businessCategories
      state.businessCategoriesFetched = true
    },
    SET_ALL_BUSINESS_CATEGORIES(state: any, businessCategories: any) {
      state.allBusinessCategories = businessCategories
      state.businessCategoriesFetched = true
    },
    TRIGGER_LOADER(state: any, loader: boolean) {
      state.businessCategoriesLoading = loader
    },
    SET_BUSINESS_CATEGORIES_FETCHED(state: any, fetched: boolean) {
      state.businessCategoriesFetched = fetched
    },
  },

  actions: {
    async FETCH_BUSINESS_CATEGORIES(context: any, { force = false, businessId = null }) {
      if (context.state.businessCategoriesLoading) {
        return []
      }
      if (context.state.businessCategoriesFetched && !force) {
        return context.state.businessCategories
      }
      context.commit('TRIGGER_LOADER', true)
      try {
        const currentBusinessTypeId = businessId ?? context.rootGetters['auth/user']?.businessType?.id
        const { businessCategories, all } = await BusinessCategoriesAPI.index(currentBusinessTypeId)
        context.commit('SET_BUSINESS_CATEGORIES', businessCategories)
        context.commit('SET_ALL_BUSINESS_CATEGORIES', all)
      } catch (err) {
        console.error(err)
      } finally {
        context.commit('TRIGGER_LOADER', false)
      }
      return context.state.businessCategories
    },
    async PUSH_BUSINESS_CATEGORY(context: any, businessCategory: any) {
      const businessCategories = [...context.state.businessCategories]
      businessCategories.unshift(businessCategory)
      context.commit('SET_BUSINESS_CATEGORIES', businessCategories)
    },
    async PUSH_ALL_BUSINESS_CATEGORY(context: any, businessCategory: any) {
      const businessCategories = [...context.state.allBusinessCategories]
      businessCategories.unshift(businessCategory)
      context.commit('SET_ALL_BUSINESS_CATEGORIES', businessCategories)
    },
  },
}
